import { SunriseCircle } from "./icons/SunriseCircle";

export const Marquee = ({ items, dark = false }) => {
  const content = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden py-8 border-y ${
        dark ? "bg-brand-forest border-brand-forestSoft" : "bg-brand-beige border-brand-beige"
      }`}
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        {content.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span
              className={`font-serif italic text-3xl md:text-5xl px-8 ${
                dark ? "text-brand-cream" : "text-brand-forest"
              }`}
            >
              {item}
            </span>
            <SunriseCircle
              className={dark ? "text-brand-goldBright" : "text-brand-gold"}
              size={26}
              strokeWidth={1}
            />
          </span>
        ))}
      </div>
    </div>
  );
};
